import { render, staticRenderFns } from "./AuthorLogin.vue?vue&type=template&id=1e038534"
import script from "./AuthorLogin.vue?vue&type=script&lang=js"
export * from "./AuthorLogin.vue?vue&type=script&lang=js"
import style0 from "./AuthorLogin.vue?vue&type=style&index=0&id=1e038534&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports